// Scroll Counters

window.SiteReady(($) => {
  console.log('Init Scroll Counters');

  const $counters = $('.js-counter');

  function observeCounters(entries) {
    entries.forEach((entry) => {
      const $el = $(entry.target);
      const edge = window.innerHeight - 200;

      if (entry.isIntersecting || entry.boundingClientRect.top < edge) {
        if (!$el.hasClass('js-counting')) {
          $el.addClass('js-counting');

          const count = $el.data('count');

          const $animation = $({ countNum: 0 }).animate({ countNum: parseInt(count, 10) }, {
            duration: 1000, // (count > 20 ? 1500 : 1000),
            easing: 'linear',
            step: function() {
              const num = ($el.data('decimal') === true) ? this.countNum.toFixed(1) : Math.ceil(this.countNum);

              $el.text(num);
            },
            complete: function() {
              $el.text(count);
            }
          });

          $el.data('animation', $animation);
        }
      } else {
        if ($el.hasClass('js-counting')) {
          const $animation = $el.data('animation');

          if ($animation) {
            $animation.stop();
          }

          $el.removeClass('js-counting').text('0');
        }
      }
    });
  }

  const observer = new IntersectionObserver(observeCounters, {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0.2
  });

  $counters.each((_, counter) => {
    observer.observe(counter);
  });

});